import { Spinner } from "@nextui-org/react"

function LoadingCard() {
  return (
    <div className="absolute  h-screen bg-slate-50 bg-opacity-60 z-10 h-full w-full flex items-center justify-center">
      <div className="flex items-center ">
        <Spinner size="lg" label="Loading..."  color="danger" labelColor="primary" />
      </div>
    </div>
    // <div className="flex h-screen items-center justify-center backdrop-opacity-10 backdrop-invert bg-rose-700/30">
    //   <Spinner size="lg" label="Loading..." labelColor="primary" />
    // </div>
  )
}
export default LoadingCard